module.exports = __webpack_public_path__ + "img/valu.f65e8e4c.svg";